import {
  UtilityBtn,
  UtilityBtnCancel,
  UtilityBtnUpdate,
} from "./profile.style";
import { useStoreWrapper } from "../../../../../store/store";
import { useFormik } from "formik";
import useUser from "../../../hooks/useUser";
import { toast } from "react-toastify";
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Avatar from "react-avatar";
import {
  IconContainer,
  UpdateUserWrapper,
} from "../../../Users/UserManagement/UpdateUser/UpdateUser.style";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
import {
  FieldContainer,
  FieldInput,
  FieldInputContainer,
  FieldLabel,
  FieldLabelContainer,
  Form,
  FormContainer,
} from "../../UpdatePassword/updatePassword.style";
import {
  convertFileToBase64,
  getChangedValues,
} from "../../../../../utils/helpers";
import { IoMdCreate } from "react-icons/io";
import Modal from "../../../../../components/Modal";
import { updateUserWithEmailSync } from "../../../hooks/updateUserWithEmailSync";
import useSyncLock from "../../../hooks/useSyncLock";

const ProfileSettings = () => {
  const { user, doUpdateUser, loggedinUserImage } = useStoreWrapper(
    (state) => ({
      user: state.user,
      doUpdateUser: state.updateUser,
      loggedinUserImage: state.loggedinUserImage,
      userFacilities: state.userFacilities,
    })
  );

  const { updateUser, handleUploadUserImage, handleGetLoggedinUserImage } =
    useUser();

  const { isLoading, mutateAsync: updateUserDetails } = updateUser;
  const { mutateAsync: uploadUserImage } = handleUploadUserImage;
  const { refetch } = handleGetLoggedinUserImage;

  const [base64String, setBase64String] = useState<string>("");

  const [avatarBase64, setAvatarBase64] = useState<string>("");
  const [isFileUpload, setIsFileUpload] = useState<boolean>(false);

  const fileInput = useRef<HTMLInputElement>(null);

  const { isSyncing, tryLock, unlock } = useSyncLock();

  const [isEdit, setIsEdit] = useState(false);
  const [viewAvatar, setViewAvatar] = useState(false);

  const handleSetEdit = useCallback(() => {
    setIsEdit(!isEdit);
  }, [isEdit, setIsEdit]);

  const { handleChange, handleSubmit, values, resetForm } = useFormik({
    initialValues: {
      username: user?.username || "",
      title: user?.title || "",
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
    },
    validationSchema: "",
    onSubmit: async (values: any) => {
      if (!tryLock()) return;

      try {
        let data = getChangedValues(values, user);
        data = {
          ...data,
          userId: user.userId,
        };

        const response = await updateUserWithEmailSync({
          salesforceContactId: user.userId,
          previousEmail: user?.email,
          newEmail: data.email,
          saveToSalesforce: () => updateUserDetails(data),
        });
        doUpdateUser(response.data.data);
        setIsEdit(false);
        toast.success(
          response?.data?.message || "User details updated successfully",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
            toastId: "1",
          }
        );
      } catch (error: any) {
        toast.error(
          error.response?.data?.message || "Something went wrong, try again",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
            toastId: "1",
          }
        );
      } finally {
        unlock();
        setIsEdit(false);
      }
    },
  });

  async function handleFileInputChange(e: ChangeEvent<HTMLInputElement>) {
    try {
      const fileToBase64 = await convertFileToBase64(e.target.files![0]);
      setBase64String(fileToBase64);
      setIsFileUpload(true);
    } catch (err) {
      console.log(err);
      setIsFileUpload(false);
    } finally {
      fileInput.current!.value = "";
    }
  }

  async function handleFileUpload() {
    const data = {
      loggedInUserId: user.userId,
      fileInBase64: base64String.replace(/^data:.+;base64,/, ""),
    };
    const response = await uploadUserImage(data);
    if (response.data.requestSuccessful) {
      setBase64String("");
      setIsFileUpload(false);
      refetch();
    }
  }

  useEffect(() => {
    if (loggedinUserImage!.length > 0) {
      const base64String = /^(?!data:)/i.test(loggedinUserImage!)
        ? "data:image/jpeg;base64," + loggedinUserImage!
        : loggedinUserImage!;
      setAvatarBase64(base64String);
    }
  }, [loggedinUserImage]);

  const checkDisabled = () => {
    return isEdit && user?.isCooperateUser;
  };

  return (
    <UpdateUserWrapper className="mb-5">
      <FormContainer>
        <Form name="profileForm" onSubmit={handleSubmit}>
          <FieldContainer>
            <FieldLabelContainer>
              <FieldLabel>Profile Photo</FieldLabel>
            </FieldLabelContainer>
            <FieldInputContainer>
              <input
                type="file"
                style={{ display: "none" }}
                accept="image/*"
                ref={fileInput}
                onChange={handleFileInputChange}
              />
              {isFileUpload && (
                <Avatar
                  src={base64String}
                  size={"50"}
                  className="cursor-pointer"
                  round
                  onClick={() => setViewAvatar(true)}
                />
              )}
              {!isFileUpload && loggedinUserImage!.length > 0 && (
                <Avatar
                  src={avatarBase64}
                  size={"50"}
                  className="cursor-pointer"
                  round
                  onClick={() => setViewAvatar(true)}
                />
              )}
              {loggedinUserImage!.length === 0 && !isFileUpload && (
                <Avatar
                  name={`${user.firstName} ${user.lastName}`}
                  size={"50"}
                  className="cursor-pointer"
                  round
                />
              )}
              {base64String.length === 0 ? null : (
                <React.Fragment>
                  <span
                    className="ml-4 cursor-pointer text-sm font-bold text-gray-400"
                    onClick={() => {
                      setBase64String("");
                      setIsFileUpload(false);
                    }}
                  >
                    Remove
                  </span>
                  <span
                    className="ml-4 cursor-pointer text-sm font-bold"
                    style={{ color: "var(--primaryPurple)" }}
                    onClick={handleFileUpload}
                  >
                    Update
                  </span>
                </React.Fragment>
              )}
              {!isFileUpload && (
                <IoMdCreate
                  style={{
                    position: "relative",
                    top: "1rem",
                    left: "0.5rem",
                    cursor: "pointer",
                  }}
                  size="25"
                  onClick={() => fileInput.current?.click()}
                />
              )}
            </FieldInputContainer>
          </FieldContainer>

          <FieldContainer>
            <FieldLabelContainer>
              <FieldLabel htmlFor="title">Title</FieldLabel>
            </FieldLabelContainer>
            <FieldInputContainer>
              <FieldInput
                name="title"
                value={values.title}
                onChange={handleChange}
                disabled={!isEdit}
              />
              <IconContainer>
                {!isEdit ? (
                  <AiFillLock color="gray" size={24} />
                ) : (
                  <AiFillUnlock color="green" size={24} />
                )}
              </IconContainer>
            </FieldInputContainer>
          </FieldContainer>

          <FieldContainer>
            <FieldLabelContainer>
              <FieldLabel htmlFor="firstName">First Name</FieldLabel>
            </FieldLabelContainer>
            <FieldInputContainer>
              <FieldInput
                name="firstName"
                value={values?.firstName}
                onChange={handleChange}
                disabled={!checkDisabled()}
              />
              <IconContainer>
                {!checkDisabled() ? (
                  <AiFillLock color="gray" size={24} />
                ) : (
                  <AiFillUnlock color="green" size={24} />
                )}
              </IconContainer>
            </FieldInputContainer>
          </FieldContainer>

          <FieldContainer>
            <FieldLabelContainer>
              <FieldLabel htmlFor="lastName">Last Name</FieldLabel>
            </FieldLabelContainer>
            <FieldInputContainer>
              <FieldInput
                name="lastName"
                value={values?.lastName}
                onChange={handleChange}
                disabled={!checkDisabled()}
              />
              <IconContainer>
                {!checkDisabled() ? (
                  <AiFillLock color="gray" size={24} />
                ) : (
                  <AiFillUnlock color="green" size={24} />
                )}
              </IconContainer>
            </FieldInputContainer>
          </FieldContainer>

          <FieldContainer>
            <FieldLabelContainer>
              <FieldLabel htmlFor="email">Email Address</FieldLabel>
            </FieldLabelContainer>
            <FieldInputContainer>
              <FieldInput
                name="email"
                value={values?.email}
                onChange={handleChange}
                disabled={!checkDisabled()}
              />
              <IconContainer>
                {!checkDisabled() ? (
                  <AiFillLock color="gray" size={24} />
                ) : (
                  <AiFillUnlock color="green" size={24} />
                )}
              </IconContainer>
            </FieldInputContainer>
          </FieldContainer>

          <FieldContainer>
            <FieldLabelContainer>
              <FieldLabel htmlFor="username">Username</FieldLabel>
            </FieldLabelContainer>
            <FieldInputContainer>
              <FieldInput
                name="username"
                value={values?.username}
                onChange={handleChange}
                disabled={!isEdit}
              />
              <IconContainer>
                {!isEdit ? (
                  <AiFillLock color="gray" size={24} />
                ) : (
                  <AiFillUnlock color="green" size={24} />
                )}
              </IconContainer>
            </FieldInputContainer>
          </FieldContainer>

          <div className="mt-7" style={{ display: "flex", gap: "1rem" }}>
            {!isEdit ? (
              <UtilityBtn buttonText="Edit" onClick={handleSetEdit}>
                Edit
              </UtilityBtn>
            ) : (
              <>
                <UtilityBtnUpdate
                  buttonText="Update"
                  type="submit"
                  disabled={isLoading || isSyncing}
                >
                  {" "}
                  {isLoading || isSyncing ? "Updating..." : "Update"}
                </UtilityBtnUpdate>
                <UtilityBtnCancel
                  buttonText="Cancel"
                  onClick={() => {
                    handleSetEdit();
                    resetForm();
                  }}
                >
                  Cancel
                </UtilityBtnCancel>
              </>
            )}
          </div>
        </Form>
      </FormContainer>
      <Modal open={viewAvatar} close={() => setViewAvatar(false)}>
        <div style={{ height: "18rem", width: "18rem", position: "relative" }}>
          <div
            onClick={() => setViewAvatar(false)}
            className="cursor-pointer text-2xl font-medium"
            style={{ position: "absolute", right: "0" }}
          >
            &times;
          </div>
          <img
            style={{
              height: "100%",
              width: "100%",
              borderRadius: "100%",
              objectFit: "cover",
            }}
            src={isFileUpload ? base64String : avatarBase64}
            alt="avatar"
          />
        </div>
      </Modal>
    </UpdateUserWrapper>
  );
};

export default ProfileSettings;
